import { useEffect, useState } from 'react';
import { useCustomer, useCustomerAuth, useCustomerLogout } from '@backpackjs/storefront';
import { AccountNav } from '@/snippets/account/AccountNav';
import { useCustomerDetails } from '@hooks';

function AccountLayout({ children }) {
  const { customerInit, customer } = useCustomerAuth();
  const { customerLogout } = useCustomerLogout();
  const [points, setPoints] = useState(0);
  const { customerDetails } = useCustomerDetails({
    email: customer?.email,
  });

  useEffect(() => {
    setPoints(customerDetails?.points_balance || 0);
  }, [customerDetails?.points_balance]);

  useEffect(() => {
    if (customerInit) {
      if (
        typeof yotpoWidgetsContainer !== 'undefined' &&
        typeof yotpoWidgetsContainer?.initWidgets !== 'undefined'
      ) {
        window.yotpoWidgetsContainer.initWidgets();
      }
    }
  }, [customerInit]);

  return (
    <div className="mx-auto lg:flex flex-wrap px-0 lg:px-12 lg:pb-[60px]">
      <div className="w-full flex lg:hidden items-start justify-between bg-grey-9 px-4 py-1 lg:mb-7 lg:flex-col lg:items-start lg:bg-transparent lg:p-0 border-b border-grey-4 sticky top-0 z-[1]">
        <div>
          <h6 className="m-0 text-h6-m lg:text-h5">
            Hello {customer.firstName}!
          </h6>
          <p className="text-primary-2 font-bold text-xs m-0">Points Balance: <span>{points}</span></p>
        </div>
        <button
          type="button"
          aria-label="Sign out"
          className="text-small font-light underline hover:no-underline lg:hidden"
          onClick={async () => {
            await customerLogout(null, () => {
              console.log('Signed Out');
            });
          }}
        >
          Sign Out
        </button>
      </div>
      <div className="w-full lg:w-[276px] lg:flex-shrink-0 lg:pr-12 lg:pt-[60px] border-r-0 lg:border-r border-grey-4">
        <div className="relative lg:sticky z-0 lg:top-[150px]">
          <div className="hidden lg:flex items-start justify-between bg-grey-9 px-4 py-1 lg:mb-7 lg:flex-col lg:items-start lg:bg-transparent lg:p-0">
            <div>
              <h6 className="m-0 text-h6-m lg:text-h5">
                Hello {customer.firstName}!
              </h6>
              <p className="text-primary-2 font-bold text-xs m-0">Points Balance: <span>{points}</span></p>
            </div>
            <button
              type="button"
              aria-label="Sign out"
              className="text-small font-light underline hover:no-underline lg:hidden"
              onClick={async () => {
                await customerLogout(null, () => {
                  console.log('Signed Out');
                });
              }}
            >
              Sign Out
            </button>
          </div>
          <div className="block">
            <AccountNav />
          </div>
        </div>
      </div>

      <div className="w-full lg:w-[calc(100%_-_276px)] lg:pt-[60px] px-5 lg:px-16 pt-4 pb-6 lg:py-0">
        <div className="mx-auto lg:max-w-[886px]">
          {children}
        </div>
      </div>
    </div>
  );
}

export default AccountLayout;
